import React from "react";

export const SliderValueContext = React.createContext();
